import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@20.9.0_@upstash+redis@1.34.3_eslint@9.13.0_j_rvohdm5e4gos7aazf5eh3xkn5y/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@20.9.0_@upstash+redis@1.34.3_eslint@9.13.0_j_rvohdm5e4gos7aazf5eh3xkn5y/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}